import queryString from 'query-string';
import Config from 'modules/config';

const baseURL = Config.API_URL;

interface BuildUrlOpts {
  url: string;
  query: object | undefined;
}
// Takes a url path and optional querys as js object, appends the base url and stringed queries
const buildURL = ({ url, query = {} }: BuildUrlOpts): string => {
  // console.devLog.info('Query:', query);
  const stringifiedQuery = queryString.stringify(query);
  // console.devLog.info('Stringified query:', stringifiedQuery);
  const fullURL = `${baseURL}${url}?${stringifiedQuery}`;
  return fullURL;
};

export default buildURL;
